import React from 'react';
import {
  Tile,
  Heading,
  Banner,
  Help,
  Bubble,
  Anchor,
  Field,
  NewInput,
  List,
  ListItem,
  NewTable,
  Icon,
  Tag,
  VStack,
  HStack,
} from '@carta/ink';
import ExposeDescribe from '../components/ExposeDescribe';

const InformationalExpose = () => {
  return (
    <ExposeDescribe
      id="Informational elements visual check"
      name="Informational elements visual check"
      key="Informational elements visual check"
    >
      <VStack spacing="xlarge">
        <Tile>
          <Heading variant="heading-2">Banner</Heading>
          <Banner
            title="Important information about your FMV"
            text="The fair market value at the date of grant ($0.246) is used for the calculation of the $100,000 rule"
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Bubble</Heading>
          <Bubble variant="feedback-informational">Most popular</Bubble>
        </Tile>

        <Tile>
          <Heading variant="heading-2">Help</Heading>
          <Help
            text="It’s important to get a full history of your company’s ownership structure. Upload all incorporation documents, including the original and any amendments/restatements"
            link={
              <Anchor href="javascript:void(0)" preset="forward">
                See examples of incorporation documents
              </Anchor>
            }
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Help as Tooltip</Heading>
          <Help
            tooltipDirection="right"
            type="tooltip"
            text="You can find this date in you Articles of Incorporation"
            link={
              <Anchor href="javascript:void(0)" wrapText preset="forward">
                See examples of effective dates in a Article of Incorporation
              </Anchor>
            }
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Field with info</Heading>
          <Field
            label="Label"
            info="Provides information on how the field interact with other parts of the application"
            htmlFor="field-with-input-and-info"
          >
            <NewInput id="field-with-input-and-info" />
          </Field>
        </Tile>

        <Tile>
          <Heading variant="heading-2">Field with Help component</Heading>
          <Field
            label="State of incorporation"
            help={
              <Help
                type="field"
                text="This is the state where your company was incorporated"
                link={
                  <Anchor href="javascript:void(0)" preset="forward">
                    See an example of where to find your state of incorporation
                  </Anchor>
                }
              />
            }
            isRequired
          >
            <NewInput id="field-input-id-1" />
          </Field>
        </Tile>

        <Tile>
          <Heading variant="heading-2">Stacked Field with Help component</Heading>
          <Field
            isStacked
            label="State of incorporation"
            help={
              <Help
                type="field"
                text="This is the state where your company was incorporated"
                link={
                  <Anchor href="javascript:void(0)" preset="forward">
                    See an example of where to find your state of incorporation
                  </Anchor>
                }
              />
            }
            isRequired
          >
            <NewInput id="field-input-id-1" />
          </Field>
        </Tile>

        <Tile>
          <Heading variant="heading-2">ListItem</Heading>
          <List>
            <ListItem
              variant="feedback-informational"
              title="Vesting report"
              text="Detailed tranche-by-tranche vesting report"
            />
            <ListItem
              size="medium"
              variant="feedback-informational"
              title="Vesting report"
              text="Detailed tranche-by-tranche vesting report"
            />
            <ListItem
              size="small"
              variant="feedback-informational"
              title="Vesting report"
              text="Detailed tranche-by-tranche vesting report"
            />
          </List>
        </Tile>

        <Tile>
          <Heading variant="heading-2">Tag</Heading>
          <HStack>
            <Tag>Base tag</Tag>
            <Tag
              action={() => (
                <Tag.Button onClick={() => alert('close button')}>
                  <Icon type="close" size="xxs" />
                </Tag.Button>
              )}
            >
              Tag with button
            </Tag>
            <Tag draggable>Movable tag</Tag>
            <Tag active>Active tag</Tag>
            <Tag size="mini">Mini tag</Tag>
            <Tag active size="mini">
              Active mini tag
            </Tag>
          </HStack>
        </Tile>

        <Tile>
          <Heading variant="heading-2">NewTableRibbon</Heading>
          <NewTable>
            <NewTable.Head>
              <NewTable.Row>
                <NewTable.HeadCell>Grant</NewTable.HeadCell>
                <NewTable.HeadCell>Issue Date</NewTable.HeadCell>
                <NewTable.HeadCell>Type</NewTable.HeadCell>
                <NewTable.HeadCell>Status</NewTable.HeadCell>
              </NewTable.Row>
            </NewTable.Head>
            <NewTable.Body>
              <NewTable.Row>
                <NewTable.Cell>
                  <NewTable.Ribbon text="Early exercisable" variant="feedback-informational" />
                  ES-161
                </NewTable.Cell>
                <NewTable.Cell>04/10/2014</NewTable.Cell>
                <NewTable.Cell>ISO</NewTable.Cell>
                <NewTable.Cell>Accepted by optionholder</NewTable.Cell>
              </NewTable.Row>
              <NewTable.Row>
                <NewTable.Cell>ES-162</NewTable.Cell>
                <NewTable.Cell>08/19/2014</NewTable.Cell>
                <NewTable.Cell>ISO</NewTable.Cell>
                <NewTable.Cell>Terminated</NewTable.Cell>
              </NewTable.Row>
              <NewTable.Row>
                <NewTable.Cell>
                  <NewTable.Ribbon text="Early exercisable" variant="feedback-informational" />
                  ES-456
                </NewTable.Cell>
                <NewTable.Cell>08/19/2014</NewTable.Cell>
                <NewTable.Cell>ISO/NSO</NewTable.Cell>
                <NewTable.Cell>Sent to optionholder</NewTable.Cell>
              </NewTable.Row>
            </NewTable.Body>
          </NewTable>
        </Tile>

        <Tile>
          <Heading variant="heading-2">NewTable footer</Heading>
          <NewTable>
            <NewTable.Head>
              <NewTable.Row>
                <NewTable.HeadCell>Stakeholder</NewTable.HeadCell>
                <NewTable.HeadCell>Security</NewTable.HeadCell>
                <NewTable.HeadCell align="right">Quantity</NewTable.HeadCell>
              </NewTable.Row>
            </NewTable.Head>
            <NewTable.Body>
              <NewTable.Row>
                <NewTable.Cell>Emily Wilson</NewTable.Cell>
                <NewTable.Cell>ES-161</NewTable.Cell>
                <NewTable.Cell align="right">10000</NewTable.Cell>
              </NewTable.Row>
              <NewTable.Row>
                <NewTable.Cell>Tagg Palmer</NewTable.Cell>
                <NewTable.Cell>ES-341</NewTable.Cell>
                <NewTable.Cell align="right">10000</NewTable.Cell>
              </NewTable.Row>
            </NewTable.Body>
            <NewTable.Foot>
              <NewTable.Row preset="totals">
                <NewTable.Cell colSpan={2}>Total</NewTable.Cell>
                <NewTable.Cell align="right">20000</NewTable.Cell>
              </NewTable.Row>
            </NewTable.Foot>
          </NewTable>
        </Tile>
      </VStack>{' '}
    </ExposeDescribe>
  );
};

export default InformationalExpose;
